import { render, staticRenderFns } from "./testFacePhoto.vue?vue&type=template&id=57a1b506&scoped=true&"
import script from "./testFacePhoto.vue?vue&type=script&lang=js&"
export * from "./testFacePhoto.vue?vue&type=script&lang=js&"
import style0 from "./testFacePhoto.vue?vue&type=style&index=0&id=57a1b506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a1b506",
  null
  
)

export default component.exports